import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  // Check BOTH localStorage AND sessionStorage
  const localToken = localStorage.getItem('mcaToken');
  const sessionToken = sessionStorage.getItem('mcaToken');
  const localUser = localStorage.getItem('mcaUser');
  const sessionUser = sessionStorage.getItem('mcaUser');
  
  const isAuthenticated = (localToken && localUser) || (sessionToken && sessionUser);
  
  console.log('ProtectedRoute check:', {
    localToken: !!localToken,
    sessionToken: !!sessionToken,
    isAuthenticated
  });

  if (!isAuthenticated) {
    console.log('Not authenticated, redirecting to login');
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
